import api from '../../services/api';
import axios from 'axios'
import Cookies from 'universal-cookie'
import { getConsultantIdentifier } from '../consultantUtils';
import ErrorService from '../../services/errorService';
import Swal from 'sweetalert2';
import { DocumentScannerOutlined } from '@mui/icons-material';
import html2pdf from 'html2pdf.js';
import { saveAs } from 'file-saver';


const data = {}


export default function tagsReducer(state = data, action) {
    switch (action.type) {
        default:
            return state;
    }
};


export const ReplaceTagsConsentimiento = (html) => (dispatch, getState) => {
    const defendido = getState().contratoV2.Defendido;
    const entrevista = getState().contratoV2.Entrevista;
    html = html.replace(/@nombre_defendido/g, defendido.firstName || "@nombre_defendido")
    html = html.replace(/@rut_defendido/g, defendido.identifier || "@rut_defendido")
    html = html.replace(/@empresa/g, entrevista.lineaNegocio || "@empresa")
    return html;
}



const opt = {
    margin: 10, filename: 'document.pdf',
    image: { type: 'jpeg', quality: 1 },
    html2canvas: { scale: 1, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
};

export const descargarPdf = (html, filename) => async (dispatch, getState) => {
    const tempElement = document.createElement('div');
    var aux = opt
    aux.filename = filename + ".pdf"
    tempElement.innerHTML = html
    await html2pdf().set(aux).from(tempElement).save();
}

export const ReplaceTagsContrato = (htmlCtto) => (dispatch, getState) => {
    htmlCtto = htmlCtto.replace(/@defensavictimas/g, "@defensavictimas")
    htmlCtto = htmlCtto.replace(/@h_acreedores/g, "@h_acreedores")
    htmlCtto = htmlCtto.replace(/@defensafamilia/g, "@defensafamilia")
    htmlCtto = htmlCtto.replace(/@defensafamilias/g, "@defensafamilias")
    htmlCtto = htmlCtto.replace(/@servicios/g, "@servicios")
    htmlCtto = htmlCtto.replace(/@firmas/gi, "")
    htmlCtto = htmlCtto.replace(/@fi/g, "@fi")

    const defendido = getState().contratoV2.Defendido;
    const pagador = getState().contratoV2.Pagador;
    const entrevista = getState().contratoV2.Entrevista;
    const general = getState().general;
    const contrato = getState().contratoV2.contrato;
    const voucher = getState().contratoV2.Cuotas;
    const acreedor = getState().contratoV2.Acreedores;
    const documento = getState().contratoV2.Documento;


    let diaEntrevista = "@dia_entrevista";
    let mesEntrevista = "@mes_entrevista";
    let anioEntrevista = "@anio_entrevista";

    if (documento && documento.getDate) {
        const fechaObj = new Date(documento.getDate);

        if (!isNaN(fechaObj.getTime())) {
            diaEntrevista = fechaObj.getDate(); // Devuelve el día del mes (1-31)
            anioEntrevista = fechaObj.getFullYear(); // Devuelve el año (ej. 2025)

            mesEntrevista = fechaObj.toLocaleString('es-CL', { month: 'long' });
        }
    }


    const negocio = general.negocios?.find(n => n.id == entrevista.lineaNegocioId);
    const siglasNegocio = negocio?.siglas || 'DEF';

    const sucursal = general.sucursales?.find(s => s.id == defendido.idBranch);
    const codigoSucursal = sucursal?.description || 'REMOTO';

    const rutNumerico = (defendido.identifier || '').replace(/[\.\-]/g, '').slice(0, -1);

    let fechaFormateada = '';
    if (documento && documento.getDate) {
        const fechaObj = new Date(documento.getDate);
        if (!isNaN(fechaObj.getTime())) {
            const dia = String(fechaObj.getDate()).padStart(2, '0');
            const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
            const anio = fechaObj.getFullYear();
            fechaFormateada = `${dia}${mes}${anio}`;
        }
    }
    console.log(entrevista)
    //const codigoContrato = `${siglasNegocio}${codigoSucursal}${rutNumerico}${fechaFormateada}` ?? "Codigo por generar";
    const codigoContrato = entrevista?.codigoContrato ?? "Codigo por generar";

    htmlCtto = htmlCtto.replace(/@fecha_act_texto/g, fechaFormateada)
    htmlCtto = htmlCtto.replace(/@fecha_texto_fin/g, fechaFormateada)

    htmlCtto = htmlCtto.replace(/@nombre_empresa_pyme/g, defendido?.pymeName?.trim() || "@nombre_empresa_pyme")
    htmlCtto = htmlCtto.replace(/@sucursal/g, general.sucursales?.find(x => x.id == defendido.idBranch)?.name || "@sucursal")
    htmlCtto = htmlCtto.replace(/@nombre_pagador/g, `${pagador?.firstName?.trim() || ""} ${pagador?.lastName?.trim() || ""}`.trim() || "@nombre_pagador")
    htmlCtto = htmlCtto.replace(/@rut_pagador/g, pagador?.identifier?.trim() || "@rut_pagador")
    htmlCtto = htmlCtto.replace(/@origen/g, entrevista?.origen?.toUpperCase().trim() || "REMOTO")
    htmlCtto = htmlCtto.replace(/@estado_civil_pagador/g, general.estadoCivil?.find(x => x.id == pagador?.idEstadoCivil)?.name?.trim() || "@estado_civil_pagador")
    htmlCtto = htmlCtto.replace(/@ocupacion_pagador/g, pagador?.ocupacion?.trim() || "@ocupacion_pagador")
    htmlCtto = htmlCtto.replace(/@ocupacion_pagaddor/g, pagador?.ocupacion?.trim() || "@ocupacion_pagaddor")
    htmlCtto = htmlCtto.replace(/@direccion_pagador/g, pagador?.address?.trim() || "@direccion_pagador")
    htmlCtto = htmlCtto.replace(/@comuna_pagador/g, general.comunas?.find(x => x.id == pagador?.idDistrito)?.description?.trim() || "@comuna_pagador")
    htmlCtto = htmlCtto.replace(/@comuna_pagado/g, general.comunas?.find(x => x.id == pagador?.idDistrito)?.description?.trim() || "@comuna_pagado")
    htmlCtto = htmlCtto.replace(/@region_pagador/g, general.regiones?.find(x => x.id == pagador?.idRegion)?.description?.trim() || "@region_pagador")
    htmlCtto = htmlCtto.replace(/@telefono_pagador/g, pagador?.telephone?.trim() || "@telefono_pagador")
    htmlCtto = htmlCtto.replace(/@celular_pagador/g, pagador?.telephone?.trim() || "@celular_pagador")
    htmlCtto = htmlCtto.replace(/@email_pagador/g, pagador?.email?.trim() || "@email_pagador")


    var cuotas = generarTablaCuotas(voucher)
    var acreedores = generarTablaAcreedores(contrato)
    var totalAmount = `${contrato.reduce((total, service) => total + (service.monto || 0), 0).toLocaleString("es-CL", { minimumFractionDigits: 0 })}` || ""

    htmlCtto = htmlCtto.replace(/@codigo_contrato/g, codigoContrato || "@codigo_contrato")
    htmlCtto = htmlCtto.replace(/@tipo_fuente/g, contrato.codCtto?.trim() || "REMOTO")
    htmlCtto = htmlCtto.replace(/@dia_entrevista/g, diaEntrevista)
    htmlCtto = htmlCtto.replace(/@mes_entrevista/g, mesEntrevista)
    htmlCtto = htmlCtto.replace(/@anio_entrevista/g, anioEntrevista)

    htmlCtto = htmlCtto.replace(/@nacionalidad_pagador/g, general.paises?.find(x => x.id == pagador?.idCountry)?.description?.trim() || "@nacionalidad_pagador")

    htmlCtto = htmlCtto.replace(/@cuotas/g, cuotas?.trim() || "@cuotas")
    htmlCtto = htmlCtto.replace(/@acreedores/g, acreedores || "@acreedores")
    htmlCtto = htmlCtto.replace(/@total_ccontrato/g, totalAmount.trim() || "@total_ccontrato")
    htmlCtto = htmlCtto.replace(/@toral_contrato/g, totalAmount.trim() || "@toral_contrato")
    htmlCtto = htmlCtto.replace(/@total_contrato/g, totalAmount.trim() || "@total_contrato")
    htmlCtto = htmlCtto.replace(/@porcentajes/g, voucher.LaborPercentage || "@porcentajes")
    return htmlCtto;
}

const generarTablaCuotas = (voucher) => {

    if (!Array.isArray(voucher.cuotas)) {
        return "<p style='color: red;'>No hay datos disponibles.</p>";
    }

    let tabla = `
      <table border="1" style="border-collapse: collapse; width: 100%; text-align: center;">
        <thead>
          <tr>
            <th>N° Cuota</th>
            <th>Fecha</th>
            <th>Monto</th>
          </tr>
        </thead>
        <tbody>`;

    function formatearFecha(fechaISO) {
        if (!fechaISO) return "<span style='background-color:orange'>Fecha no disponible</span>";
        /*let fecha = new Date(fechaISO);
        let dia = fecha.getDate();
        let mes = fecha.getMonth() + 1;
        let año = fecha.getFullYear();
        return `${dia}/${mes.toString().padStart(2, "0")}/${año}`;
        */
        const [año, mes, dia] = fechaISO.split("-");
        return `${dia}/${mes}/${año}`;
    }

    voucher.cuotas.forEach(cuota => {
        tabla += `
      <tr>
          <td>${(cuota.id !== null && cuota.id !== undefined && cuota.id !== "")
                ? (cuota.id === 0 ? "<span>Pie</span>" : cuota.id)
                : "<span style='background-color:orange'>Sin número</span>"}</td>
          <td>${formatearFecha(cuota.fecha)}</td>
          <td>${cuota.monto ? cuota.monto.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) : "<span style='background-color:orange'>Monto no disponible</span>"}</td>
      </tr>`;
    });

    return tabla + ` </tbody> </table> `
}

const generarTablaAcreedores = (contrato) => {

    let tabla = `
      <table border="1" style="border-collapse: collapse; width: 100%; text-align: center;">
        <thead>
          <tr>
            <th>Acreedor</th>
            <th>Monto</th>
          </tr>
        </thead>
        <tbody>`;


    contrato.forEach((service) => {
        service.acreedores.forEach((acreedores) => {
            tabla += `
      <tr>
          <td>${acreedores.name}</td>
          <td>${acreedores.monto ? acreedores.monto.toLocaleString("es-CL", { style: "currency", currency: "CLP" }) : "<span style='background-color:orange'>Monto no disponible</span>"}</td>
      </tr>`;
        });
    });

    return tabla + ` </tbody> </table> `;
}

export const ReplaceTagsActualizacion = (htmlCtto) => (dispatch, getState) => {

    //no identificados
    htmlCtto = htmlCtto.replace(/@defensavictimas/g, "@defensavictimas")
    htmlCtto = htmlCtto.replace(/@h_acreedores/g, "@h_acreedores")
    htmlCtto = htmlCtto.replace(/@defensafamilia/g, "@defensafamilia")
    htmlCtto = htmlCtto.replace(/@defensafamilias/g, "@defensafamilias")
    htmlCtto = htmlCtto.replace(/@servicios/g, "@servicios")
    htmlCtto = htmlCtto.replace(/@firmas/gi, "")//"@firmas"
    htmlCtto = htmlCtto.replace(/@fi/g, "@fi")


    const defendido = getState().contratoV2.Defendido;
    const pagador = getState().contratoV2.Pagador;
    const entrevista = getState().contratoV2.Entrevista;
    const general = getState().general;
    const contrato = getState().contratoV2.contrato;
    const voucher = getState().contratoV2.Cuotas;
    const acreedor = getState().contratoV2.Acreedores;
    const documento = getState().contratoV2.Documento;
    const actualizacion = getState().contratoV2.Actualizacion;



    let diaEntrevista = "@dia_entrevista";
    let mesEntrevista = "@mes_entrevista";
    let anioEntrevista = "@anio_entrevista";
    let fechaFormateada = '';

    const fechaObj = new Date();
    if (!isNaN(fechaObj.getTime())) {
        diaEntrevista = fechaObj.getDate(); // Devuelve el día del mes (1-31)
        anioEntrevista = fechaObj.getFullYear(); // Devuelve el año (ej. 2025)
        mesEntrevista = fechaObj.toLocaleString('es-CL', { month: 'long' });
        fechaFormateada = `${diaEntrevista}${anioEntrevista}${mesEntrevista}`;
    }

    htmlCtto = htmlCtto.replace(/@fecha_act_texto/g, fechaFormateada)
    htmlCtto = htmlCtto.replace(/@fecha_texto_fin/g, fechaFormateada)

    const negocio = general.negocios?.find(n => n.id == entrevista.lineaNegocioId);
    const siglasNegocio = negocio?.siglas || 'DEF';

    const sucursal = general.sucursales?.find(s => s.id == defendido.idBranch);
    const codigoSucursal = sucursal?.description || 'REMOTO';

    const rutNumerico = (defendido.identifier || '').replace(/[\.\-]/g, '').slice(0, -1);

    const codigoContrato = entrevista?.codigoContrato ?? `${siglasNegocio}${codigoSucursal}${rutNumerico}${fechaFormateada}`;


    const _ActDefendido = actualizacion.actualizacionModelos?.find(x => x.model == "defendido")?.json
    const ActDefendido = _ActDefendido ? JSON.parse(_ActDefendido) : null
    const _ActPagador = actualizacion.actualizacionModelos?.find(x => x.model == "pagador")?.json
    const ActPagador = _ActPagador ? JSON.parse(_ActPagador) : null
    const _ActServicio = actualizacion.actualizacionModelos?.find(x => x.model == "servicio")?.json
    const ActServicio = _ActServicio ? JSON.parse(_ActServicio) : null
    const _ActVoucher = actualizacion.actualizacionModelos?.find(x => x.model == "voucher")?.json
    const ActVoucher = _ActVoucher ? JSON.parse(_ActVoucher) : null

    /** PERMANENTES */
    htmlCtto = htmlCtto.replace(/@origen/g, entrevista?.origen?.toUpperCase().trim() || "REMOTO")
    htmlCtto = htmlCtto.replace(/@codigo_contrato/g, codigoContrato || "@codigo_contrato")
    htmlCtto = htmlCtto.replace(/@tipo_fuente/g, contrato.codCtto?.trim() || "REMOTO")
    htmlCtto = htmlCtto.replace(/@dia_entrevista/g, diaEntrevista)
    htmlCtto = htmlCtto.replace(/@mes_entrevista/g, mesEntrevista)
    htmlCtto = htmlCtto.replace(/@anio_entrevista/g, anioEntrevista)

    /** MODIFICABLES */
    if (ActDefendido) {

        htmlCtto = htmlCtto.replace(/@nombre_empresa_pyme/g, ActDefendido?.pymeName?.trim() || "@nombre_empresa_pyme")
        htmlCtto = htmlCtto.replace(/@sucursal/g, general.sucursales?.find(x => x.id == ActDefendido.idBranch)?.name || "@sucursal")
    } else {

        htmlCtto = htmlCtto.replace(/@nombre_empresa_pyme/g, defendido?.pymeName?.trim() || "@nombre_empresa_pyme")
        htmlCtto = htmlCtto.replace(/@sucursal/g, general.sucursales?.find(x => x.id == defendido.idBranch)?.name || "@sucursal")
    }

    if (ActPagador) {
        htmlCtto = htmlCtto.replace(/@nombre_pagador/g, `${ActPagador.firstName?.trim() || ""} ${ActPagador.lastName?.trim() || ""}`.trim() || "@nombre_pagador")
        htmlCtto = htmlCtto.replace(/@rut_pagador/g, ActPagador.identifier?.trim() || "@rut_pagador")
        htmlCtto = htmlCtto.replace(/@estado_civil_pagador/g, general.estadoCivil?.find(x => x.id == ActPagador.idEstadoCivil)?.name?.trim() || "@estado_civil_pagador")
        htmlCtto = htmlCtto.replace(/@ocupacion_pagador/g, ActPagador.ocupacion?.trim() || "@ocupacion_pagador")
        htmlCtto = htmlCtto.replace(/@ocupacion_pagaddor/g, ActPagador.ocupacion?.trim() || "@ocupacion_pagaddor")
        htmlCtto = htmlCtto.replace(/@direccion_pagador/g, ActPagador.address?.trim() || "@direccion_pagador")
        htmlCtto = htmlCtto.replace(/@comuna_pagador/g, general.comunas?.find(x => x.id == ActPagador.idDistrito)?.description?.trim() || "@comuna_pagador")
        htmlCtto = htmlCtto.replace(/@comuna_pagado/g, general.comunas?.find(x => x.id == ActPagador.idDistrito)?.description?.trim() || "@comuna_pagado")
        htmlCtto = htmlCtto.replace(/@region_pagador/g, general.regiones?.find(x => x.id == ActPagador.idRegion)?.description?.trim() || "@region_pagador")
        htmlCtto = htmlCtto.replace(/@telefono_pagador/g, ActPagador.telephone?.trim() || "@telefono_pagador")
        htmlCtto = htmlCtto.replace(/@celular_pagador/g, ActPagador.telephone?.trim() || "@celular_pagador")
        htmlCtto = htmlCtto.replace(/@email_pagador/g, ActPagador.email?.trim() || "@email_pagador")
        htmlCtto = htmlCtto.replace(/@nacionalidad_pagador/g, general.paises?.find(x => x.id == ActPagador.idCountry)?.description?.trim() || "@nacionalidad_pagador")
    } else {
        htmlCtto = htmlCtto.replace(/@nombre_pagador/g, `${pagador?.firstName?.trim() || ""} ${pagador?.lastName?.trim() || ""}`.trim() || "@nombre_pagador")
        htmlCtto = htmlCtto.replace(/@rut_pagador/g, pagador?.identifier?.trim() || "@rut_pagador")
        htmlCtto = htmlCtto.replace(/@estado_civil_pagador/g, general.estadoCivil?.find(x => x.id == pagador?.idEstadoCivil)?.name?.trim() || "@estado_civil_pagador")
        htmlCtto = htmlCtto.replace(/@ocupacion_pagador/g, pagador?.ocupacion?.trim() || "@ocupacion_pagador")
        htmlCtto = htmlCtto.replace(/@ocupacion_pagaddor/g, pagador?.ocupacion?.trim() || "@ocupacion_pagaddor")
        htmlCtto = htmlCtto.replace(/@direccion_pagador/g, pagador?.address?.trim() || "@direccion_pagador")
        htmlCtto = htmlCtto.replace(/@comuna_pagador/g, general.comunas?.find(x => x.id == pagador?.idDistrito)?.description?.trim() || "@comuna_pagador")
        htmlCtto = htmlCtto.replace(/@comuna_pagado/g, general.comunas?.find(x => x.id == pagador?.idDistrito)?.description?.trim() || "@comuna_pagado")
        htmlCtto = htmlCtto.replace(/@region_pagador/g, general.regiones?.find(x => x.id == pagador?.idRegion)?.description?.trim() || "@region_pagador")
        htmlCtto = htmlCtto.replace(/@telefono_pagador/g, pagador?.telephone?.trim() || "@telefono_pagador")
        htmlCtto = htmlCtto.replace(/@celular_pagador/g, pagador?.telephone?.trim() || "@celular_pagador")
        htmlCtto = htmlCtto.replace(/@email_pagador/g, pagador?.email?.trim() || "@email_pagador")
        htmlCtto = htmlCtto.replace(/@nacionalidad_pagador/g, general.paises?.find(x => x.id == pagador?.idCountry)?.description?.trim() || "@nacionalidad_pagador")
    }

    var acreedores = generarTablaAcreedores(contrato)
    var totalAmount = `${contrato.reduce((total, service) => total + (service.monto || 0), 0).toLocaleString("es-CL", { minimumFractionDigits: 0 })}` || ""

    if (ActServicio) {
        //acreedores
        if (ActServicio.servicios?.some(s => s.acreedores?.length > 0) ?? false) {
            acreedores = generarTablaAcreedores(ActServicio.servicios)
        }
        //monto total servicios
        if (ActServicio.servicios?.some(() => true) ?? false) {
            totalAmount = `${ActServicio.servicios.reduce((suma, service) => suma + (service.monto || 0), 0).toLocaleString("es-CL", { minimumFractionDigits: 0 })}` || ""
        }
    }
    // acreedores
    htmlCtto = htmlCtto.replace(/@acreedores/g, acreedores || "@acreedores")
    //servicios
    htmlCtto = htmlCtto.replace(/@total_ccontrato/g, totalAmount.trim() || "@total_ccontrato")
    htmlCtto = htmlCtto.replace(/@toral_contrato/g, totalAmount.trim() || "@toral_contrato")
    htmlCtto = htmlCtto.replace(/@total_contrato/g, totalAmount.trim() || "@total_contrato")
    console.log(voucher)
    console.log(ActVoucher)

    var cuotas = ""
    var laborPercentage = 0
    console.log(cuotas)
    if (ActVoucher) {
        cuotas = generarTablaCuotas(ActVoucher) //  revisar pie
        laborPercentage = ActVoucher.LaborPercentage ?? 0 //revisar
    } else {
        cuotas = generarTablaCuotas(voucher)
        laborPercentage = voucher.LaborPercentage ?? 0
    }
    console.log(cuotas)
    //cuotas y laborar
    htmlCtto = htmlCtto.replace(/@cuotas/g, cuotas?.trim() || "@cuotas")
    htmlCtto = htmlCtto.replace(/@porcentajes/g, laborPercentage, "@porcentajes")

    return htmlCtto;
}